module.exports = __webpack_public_path__ + "static/media/hip_rot.89d75d00.png";